import https from "../../configs/axios.config";
import { API_ROUTES } from "../../constants/API_ROUTES";

export const postsService = {
  get: async (search, token, page = 1, limit = 10) => {
    const response = await https.get(
      `${API_ROUTES.POSTS.GET}?search_value=${search}&page=${page}&limit=${limit}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  },
  get_by_id: async (id, token) => {
    const response = await https.get(`${API_ROUTES.POSTS.GET_BY_ID}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  create: async (data, token) => {
    const response = await https.post(`${API_ROUTES.POSTS.CREATE}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  update: async (id, data, token) => {
    const response = await https.put(`${API_ROUTES.POSTS.UPDATE}/${id}`, data, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
  delete: async (id, token) => {
    const response = await https.delete(`${API_ROUTES.POSTS.DELETE}/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response;
  },
};
